var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKaktu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    rx: 20,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5434 35.4314C76.3353 42.5408 76.3353 54.1065 68.5434 61.2159L68.3048 61.4336C60.63 68.4363 48.1926 68.4363 40.5178 61.4336C32.7799 54.3735 32.4198 42.8776 40.0091 35.6819C47.7785 28.326 60.6615 28.2398 68.5434 35.4314ZM74.8183 29.7101C63.5514 19.43 45.2803 19.43 34.0088 29.7101C22.7419 39.9903 22.7419 56.6611 34.0088 66.9454L54.4135 85.563L74.8183 66.9454C86.0853 56.6611 86.0853 39.9903 74.8183 29.7101Z",
    fill: "#FC7449"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4182 57.8945C51.518 57.8945 51.518 56.9967 51.518 55.8908L51.9533 50.8793C49.5327 49.9815 47.8184 47.8063 47.8184 45.2598C47.8184 41.9134 50.7719 39.1995 54.4138 39.1995C58.0557 39.1995 61.0092 41.9134 61.0092 45.2598C61.0092 47.8063 59.2993 49.9815 56.8743 50.8793L57.3095 55.8908C57.3184 56.9967 57.3184 57.8945 54.4182 57.8945Z",
    fill: "#FC7449"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaktu);
export default __webpack_public_path__ + "static/media/kaktu.23149e09644621e9250f97336e85be4a.svg";
export { ForwardRef as ReactComponent };